import { Helmet } from "react-helmet-async"

interface CanonicalTagProps {
  url: string
}

const SITE_ORIGIN = "https://autowrapsandiego.com"

export default function CanonicalTag({ url }: CanonicalTagProps) {
  // Accept both absolute URLs (https://autowrapsandiego.com/path) and relative
  // paths (/path) without ever duplicating the domain.
  const fullUrl = /^https?:\/\//i.test(url)
    ? url
    : `${SITE_ORIGIN}${url.startsWith("/") ? url : `/${url}`}`

  return (
    <Helmet>
      <link rel="canonical" href={fullUrl} />
    </Helmet>
  )
}
